// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"OD-z","modalContent":"PD-z","header":"QD-z","close":"RD-z"};